import { ActionContext } from 'vuex'
import apiAdminMissionGlobal from '@/api/admin/missionGlobal'
import { DETAIL_REFUSED } from '@/utils/tenantModules'
import util from '@/utils/classToObject'
import types from '@/store/all-mutation-types'
import { IRootState } from '@/store'
import { IMissionGlobalState } from './state'
import { ApiResultCode } from '@/models/response/AlrBase'
import {
  AloDbMissionGlobal,
  isAloDbMissionGlobalCoverage,
  isAloDbMissionGlobalFormation,
  isAloDbMissionGlobalSimulation,
} from '@/models/alodb/AloDbMissionGlobal'
import { AloError } from '@/models/alo/AloError'
import { AloBaseArray } from '@/models/alo/AloBaseArray'
import { router } from '@/mainjs.js'
import { buildSimulationUIStateId } from '@/models/ui/SimulationUiState'
import { i18n } from '@/locale/vueI18n'
import Vue from 'vue'
import { getDefaultSmartResultGridCoverage } from '@/models/iris/smartMission/ISmartResultGridCoverage'
import { CoverageStep } from '@/enum/CoverageStep'
import { CoverageState } from '@/enum/CoverageState'
import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'
import { WobAdminChanged } from '@/models/wob/WobAdminChanged'
import { buildCoverageStateId } from '@/models/ui/CoverageUiState'

export class MissionGlobalAction {
  public [types.MISSIONGLOBAL_REQUEST](context: ActionContext<IMissionGlobalState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONGLOBAL_REQUEST)
      apiAdminMissionGlobal
        .getMissionGlobals()
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const missionGlobalArray = resp.data.data as AloBaseArray<AloDbMissionGlobal>
            const mustShowAll = context.state.missionGlobalsId.length == 0
            context.commit(types.MISSIONGLOBAL_SUCCESS, missionGlobalArray.items)
            //premiere requete on affiche tout
            //if(mustShowAll) context.dispatch(types.UI_SHOW_ALL_SIMULATION_MISSION_MAP,'map_global')
            resolve(missionGlobalArray.items)
          } else {
            context.commit(types.MISSIONGLOBAL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(resp => {
          context.commit(types.MISSIONGLOBAL_ERROR)
          reject()
        })
    })
  }

  public [types.MISSIONGLOBAL_ENSURE_LIST](context: ActionContext<IMissionGlobalState, IRootState>) {
    if (!context.state.missionLoaded) {
      return context.dispatch(types.MISSIONGLOBAL_REQUEST)
    } else {
      return new Promise((resolve, reject) => {
        resolve(context.getters.missionGlobals)
      })
    }
  }

  public async [types.MISSIONGLOBAL_SELECT_DETAIL](
    context: ActionContext<IMissionGlobalState, IRootState>,
    itemId: number,
  ) {
    const missionGlobal = context.getters.missionGlobalsById[itemId] as AloDbMissionGlobal
    if (missionGlobal) {
      if (missionGlobal.detailLoaded) {
        await Promise.all([
          context.dispatch(types.UI_ENSURE_MISSIONPLAN_STATE, { id: missionGlobal.MIG_ID, typeUiid: 'simulation' }),
          context.dispatch(types.UI_ENSURE_MISSIONGLOBAL_STATE, { ids: [missionGlobal.MIG_ID], typeUiid: 'detail' }),
        ])
        context.commit(types.MISSIONGLOBAL_SELECT_DETAIL, missionGlobal)
        return missionGlobal
      } else {
        context.dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, itemId).then(ens => {
          context.commit(types.MISSIONGLOBAL_SELECT_DETAIL, ens)
          return ens
        })
      }
    } else {
      context.commit(types.MISSIONGLOBAL_SELECT_DETAIL, new AloDbMissionGlobal())
    }
  }

  public async [types.MISSIONGLOBAL_OPEN_DETAIL](
    context: ActionContext<IMissionGlobalState, IRootState>,
    itemId: number,
  ) {
    let missionGlobal = context.getters.missionGlobalsById[itemId] as AloDbMissionGlobal
    if (!missionGlobal || !missionGlobal.detailLoaded) {
      await context.dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, itemId)
      missionGlobal = context.getters.missionGlobalsById[itemId] as AloDbMissionGlobal
    }
    // BLF037 — scénario refusé par les réglages de son enseigne : aucun onglet ouvert.
    if (!context.getters.isMissionGlobalAllowed(missionGlobal)) throw new Error(DETAIL_REFUSED)
    await Promise.all([
      context.dispatch(types.UI_ENSURE_MISSIONGLOBAL_STATE, { ids: [missionGlobal.MIG_ID], typeUiid: 'detail' }),
      context.dispatch(types.UI_ENSURE_MISSION_STATE, { ids: missionGlobal.misIdArray, typeUiid: 'detail' }),
    ])
    const isAlreadyOpen = context.state.detailSimulations.findIndex(id => id == itemId) > -1
    await Promise.all([
      context.dispatch(types.MISSIONVIRTUAL_ENSURE_LIST),
      context.dispatch(types.COVERAGEITERATION_ENSURE_LIST),
      context.commit(types.MISSIONGLOBAL_OPEN_DETAIL, missionGlobal),
    ])

    //Après ouverture d'un nouvel onglet on affiche toujours la derniere mission et on la selectionne
    if (!isAlreadyOpen) {
      context.dispatch(types.MISSIONGLOBAL_OPEN_LAST_SIMULATION, itemId)
    }
  }

  public async [types.MISSIONGLOBAL_OPEN_LAST_SIMULATION](
    context: ActionContext<IMissionGlobalState, IRootState>,
    itemId: number,
  ) {
    let missionGlobal = context.getters.missionGlobalsById[itemId] as AloDbMissionGlobal
    if (isAloDbMissionGlobalSimulation(missionGlobal)) {
      //Après ouverture d'un nouvel onglet on affiche toujours la derniere mission et on la selectionne
      const maxVimId = Math.max(...missionGlobal.misIdArray, -1)
      if (maxVimId > -1) {
        const newMissionMapVisibility = missionGlobal.misIdArray.reduce((newVisi, id) => {
          newVisi[id] = id == maxVimId
          return newVisi
        }, {} as { [id: number]: boolean })
        context.commit(types.UI_SHOW_ALL_DRAWER_MISSION_MAP, { newMissionMapVisibility, uiid: '' })
        const map_uiid = buildSimulationUIStateId(missionGlobal.MIG_ID!, 'map')
        await Promise.all([
          context.dispatch(types.UI_SELECT_MISSION_MAP, { id: maxVimId, uiid: map_uiid }),
          //context.dispatch(types.UI_TOGGLE_SIMULATION_INFOS_VISIBILITY, {missionId:maxVimId})
        ])
      }
    } else if (isAloDbMissionGlobalCoverage(missionGlobal) || isAloDbMissionGlobalFormation(missionGlobal)) {
      const finishedCovId = (context.rootGetters.coverageIterations as Array<AloDbCoverageIteration>)
        .filter(
          ci =>
            ci.MIG_ID == itemId &&
            ci.COV_PROCESSING_STEP == CoverageStep.FinalSimulation &&
            (ci.COV_PROCESSING_STATE == CoverageState.aborted || ci.COV_PROCESSING_STATE == CoverageState.finished),
        )
        .map(ci => ci.COV_ID!)
      const maxCovid = Math.max(...finishedCovId, -1)
      if (maxCovid > -1) {
        await context.dispatch(types.COVERAGEITERATION_SELECT_DETAIL, maxCovid)
      }
    }
  }

  public [types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST](
    context: ActionContext<IMissionGlobalState, IRootState>,
    itemId: number,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, itemId)
      apiAdminMissionGlobal
        .getMissionGlobal(itemId)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //lance la creation des models de mission state Ui si necessaire
            const missionGlobal = resp.data.data as AloDbMissionGlobal
            Promise.all([
              context.dispatch(types.UI_ENSURE_MISSIONPLAN_STATE, { id: missionGlobal.MIG_ID, typeUiid: 'simulation' }),
              context.dispatch(types.UI_ENSURE_MISSIONGLOBAL_STATE, {
                ids: [missionGlobal.MIG_ID],
                typeUiid: 'detail',
              }),
            ]).then(() => {
              context.commit(types.MISSIONGLOBAL_SELECT_DETAIL_SUCCESS, missionGlobal)
              context.commit(types.MISSIONGLOBAL_SET_MODIFIED_ADM, missionGlobal)
              //context.commit(types.MISSIONGLOBAL_SELECT_DETAIL,missionGlobal)
              resolve(missionGlobal)
            })
          } else {
            context.commit(types.MISSIONGLOBAL_SELECT_DETAIL_ERROR)
            reject(resp.data.data as AloError)
          }
        })
        .catch(() => {
          context.commit(types.MISSIONGLOBAL_SELECT_DETAIL_ERROR)
          reject()
        })
    })
  }

  public [types.MISSIONGLOBAL_SAVE_REQUEST](context: ActionContext<IMissionGlobalState, IRootState>) {
    return new Promise((resolve, reject) => {
      //const tryRedirect = !context.getters.modifiedAdmMissionGlobal.id
      context.commit(types.MISSIONGLOBAL_SAVE_REQUEST, context.getters.modifiedAdmMissionGlobal.MIG_LIBELLE)
      //synchronise les sensors
      context.commit(types.SIMULATION_SYNC_MISSSIONPLAN_SENSOR, context.getters.modifiedAdmMissionGlobal)
      apiAdminMissionGlobal
        .saveMissionGlobal(context.getters.modifiedAdmMissionGlobal)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            const missionGlobal = resp.data.data as AloDbMissionGlobal
            context.commit(types.MISSIONGLOBAL_SELECT_DETAIL_SUCCESS, missionGlobal)
            context.commit(types.MISSIONGLOBAL_SET_MODIFIED_ADM, missionGlobal)
            context.commit(types.MISSIONGLOBAL_SELECT_DETAIL, missionGlobal)
            //context.dispatch("UI_ADD_SNACK_MESSAGE",i18n.t('Admin.SaveOk',{item:missionGlobal.MIG_LIBELLE}))
            //if(tryRedirect && router.app.$route.name === 'SmartPlanning') router.push({name:'SmartPlanningDetail',params:{simulationid:missionGlobal.id!.toString()}})
            resolve(missionGlobal)
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MISSIONGLOBAL_SAVE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MISSIONGLOBAL_SAVE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSave', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnSave'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONGLOBAL_DELETE_REQUEST](
    context: ActionContext<IMissionGlobalState, IRootState>,
    missionGlobal: AloDbMissionGlobal,
  ) {
    return new Promise<void>((resolve, reject) => {
      const missionGlobalId = missionGlobal ? missionGlobal.id! : context.getters.originalAdmMissionGlobal.id!
      const missionGlobalLabel = missionGlobal
        ? missionGlobal.MIG_LIBELLE
        : context.getters.originalAdmMissionGlobal.MIG_LIBELLE

      const cascading = missionGlobal
        ? isAloDbMissionGlobalSimulation(missionGlobal)
        : isAloDbMissionGlobalSimulation(context.getters.originalAdmMissionGlobal)
      context.commit(types.MISSIONGLOBAL_DELETE_REQUEST, missionGlobalLabel)
      apiAdminMissionGlobal
        .deleteMissionGlobal(missionGlobalId, cascading)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context.commit(types.MISSIONGLOBAL_DELETE_SUCCESS, missionGlobalId)
            resolve()
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MISSIONGLOBAL_DELETE_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorDelete', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MISSIONGLOBAL_DELETE_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorDelete', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnDelete'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONGLOBAL_ABORT_SIMULATION_REQUEST](context: ActionContext<IMissionGlobalState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONGLOBAL_ABORT_SIMULATION_REQUEST, context.getters.originalAdmMissionGlobal.MIG_LIBELLE)
      apiAdminMissionGlobal
        .abortSimulation(context.getters.modifiedAdmMissionGlobal)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //Recup les mission virtuelles
            context.dispatch(types.MISSIONVIRTUAL_REQUEST).then(resultMisVirtual => {
              context
                .dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, context.getters.originalAdmMissionGlobal.MIG_ID)
                .then((result: AloDbMissionGlobal) => {
                  context.dispatch(types.MISSIONGLOBAL_OPEN_DETAIL, result.MIG_ID).then(() => {
                    context.dispatch(types.MISSIONGLOBAL_OPEN_LAST_SIMULATION, result.MIG_ID).then(() => {
                      resolve(result)
                    })
                  })
                })
            })
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MISSIONGLOBAL_ABORT_SIMULATION_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorStopSimulation', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MISSIONGLOBAL_ABORT_SIMULATION_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorStopSimulation', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnStopSimulation'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONGLOBAL_RUN_SIMULATION_REQUEST](context: ActionContext<IMissionGlobalState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONGLOBAL_RUN_SIMULATION_REQUEST, context.getters.originalAdmMissionGlobal.MIG_LIBELLE)
      Vue.set(context.state.simuLaunchDic, context.getters.originalAdmMissionGlobal.MIG_ID, true)
      apiAdminMissionGlobal
        .runSimulation(context.getters.originalAdmMissionGlobal)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            //Recup les mission virtuelles
            context.dispatch(types.MISSIONVIRTUAL_REQUEST).then(resultMisVirtual => {
              context
                .dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, context.getters.originalAdmMissionGlobal.MIG_ID)
                .then((result: AloDbMissionGlobal) => {
                  context.dispatch(types.MISSIONGLOBAL_OPEN_DETAIL, result.MIG_ID).then(() => {
                    context.dispatch(types.MISSIONGLOBAL_OPEN_LAST_SIMULATION, result.MIG_ID).then(() => {
                      resolve(result)
                    })
                  })
                })
            })

            //Recup le detail de la mission Global
            // context.dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST,context.getters.originalAdmMissionGlobal.MIG_ID).then((result:AloDbMissionGlobal) =>{
            //   const maxId = result.misIdArray.reduce((max,id)=> id>max?id:max ,0)
            //   context.dispatch(types.MISSIONVIRTUAL_SELECT_DETAIL_REQUEST,maxId).then(resultMisVirtual=>{
            //     resolve(result)
            //   })
            // })
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            context.commit(types.MISSIONGLOBAL_RUN_SIMULATION_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSimulation', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          context.commit(types.MISSIONGLOBAL_RUN_SIMULATION_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorSimulation', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnSimulation'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONGLOBAL_RUN_COVERAGE_GRID_REQUEST](context: ActionContext<IMissionGlobalState, IRootState>) {
    return new Promise((resolve, reject) => {
      apiAdminMissionGlobal
        .processCoverageGrid(context.getters.originalAdmMissionGlobal)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context
              .dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, context.getters.originalAdmMissionGlobal.MIG_ID)
              .then((result: AloDbMissionGlobal) => {
                resolve(result)
              })
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            //context.commit(types.MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR)
            const error = resp.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorCoverageGrid', { error: error.errorMessage }))
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          //context.commit(types.MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorCoverageGrid', { error: er.errorMessage }))
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnCoverageGrid'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONGLOBAL_RUN_COVERAGE_SIMULATION_REQUEST](
    context: ActionContext<IMissionGlobalState, IRootState>,
  ) {
    return new Promise((resolve, reject) => {
      apiAdminMissionGlobal
        .processCoverageSimulation(context.getters.originalAdmMissionGlobal)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context
              .dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, context.getters.originalAdmMissionGlobal.MIG_ID)
              .then((result: AloDbMissionGlobal) => {
                resolve(result)
              })
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            //context.commit(types.MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR)
            const error = resp.data.data as AloError
            context.dispatch(
              'UI_ADD_SNACK_MESSAGE',
              i18n.t('Admin.ErrorCoverageSimulation', { error: error.errorMessage }),
            )
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          //context.commit(types.MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch(
              'UI_ADD_SNACK_MESSAGE',
              i18n.t('Admin.ErrorCoverageSimulation', { error: er.errorMessage }),
            )
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnCoverageSimulation'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONGLOBAL_RUN_FORMATION_SIMULATION_REQUEST](
    context: ActionContext<IMissionGlobalState, IRootState>,
  ) {
    return new Promise((resolve, reject) => {
      apiAdminMissionGlobal
        .processFormationSimulation(context.getters.originalAdmMissionGlobal)
        .then(resp => {
          if (resp.data.resultCode == ApiResultCode.Ok) {
            context
              .dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, context.getters.originalAdmMissionGlobal.MIG_ID)
              .then((result: AloDbMissionGlobal) => {
                resolve(result)
              })
          } else {
            console.error('ATTENTION une reponse Code 200 contient une erreur')
            //context.commit(types.MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR)
            const error = resp.data.data as AloError
            context.dispatch(
              'UI_ADD_SNACK_MESSAGE',
              i18n.t('Admin.ErrorFormationSimulation', { error: error.errorMessage }),
            )
            console.error(error)
            reject(error)
          }
        })
        .catch(error => {
          //context.commit(types.MISSIONGLOBAL_RUN_COVERAGE_GRID_ERROR)
          if (error.response) {
            const er = error.response.data.data as AloError
            context.dispatch(
              'UI_ADD_SNACK_MESSAGE',
              i18n.t('Admin.ErrorFormationSimulation', { error: er.errorMessage }),
            )
            console.error(er)
            reject(er)
          } else {
            context.dispatch('UI_ADD_SNACK_MESSAGE', i18n.t('Admin.ErrorOnFormationSimulation'))
            reject()
          }
        })
    })
  }

  public [types.MISSIONGLOBAL_UPDATE_MODIFIED_ADM](
    context: ActionContext<IMissionGlobalState, IRootState>,
    newProperties: Object,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONGLOBAL_SET_MODIFIED_ADM, {
        ...context.getters.modifiedAdmMissionGlobal,
        ...newProperties,
      })
      resolve(context.getters.modifiedAdmMissionGlobal)
    })
  }

  public [types.MISSIONGLOBAL_CANCEL_MODIFIED_ADM](context: ActionContext<IMissionGlobalState, IRootState>) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONGLOBAL_SET_MODIFIED_ADM, context.getters.originalAdmMissionGlobal)
      resolve(context.getters.modifiedAdmMissionGlobal)
    })
  }

  public [types.MISSIONGLOBAL_UPDATE_FILTER_ADM](
    context: ActionContext<IMissionGlobalState, IRootState>,
    newProperties: Object,
  ) {
    return new Promise((resolve, reject) => {
      context.commit(types.MISSIONGLOBAL_UPDATE_FILTER_ADM, newProperties)
      resolve(context.state.adminFilter)
    })
  }

  public [types.MISSIONGLOBAL_UNSELECT_DETAIL](context: ActionContext<IMissionGlobalState, IRootState>, id: number) {
    context.commit(types.MISSIONGLOBAL_UNSELECT_DETAIL, id)
    return context.dispatch(types.UI_RESET_UISTATE, buildSimulationUIStateId(id, 'detail'))
  }

  public [types.SIMULATION_SYNC_MISSSIONPLAN_SENSOR](context: ActionContext<IMissionGlobalState, IRootState>) {
    return new Promise<void>((resolve, reject) => {
      context.commit(types.SIMULATION_SYNC_MISSSIONPLAN_SENSOR, context.getters.modifiedAdmMissionGlobal)
      resolve()
    })
  }

  public [types.MISSIONGLOBAL_EXTERNAL_UPDATE](
    context: ActionContext<IMissionGlobalState, IRootState>,
    wob: WobAdminChanged<AloDbMissionGlobal>,
  ) {
    return new Promise<void>((resolve, reject) => {
      if (wob.actionType == 'Deleted') {
        context.commit(types.MISSIONGLOBAL_EXTERNAL_UPDATE, wob)
      } else {
        const newIdx = context.rootState.missionGlobal.detailSimulations.findIndex(id => id == wob.newAloDbItem.MIG_ID)
        if (wob.actionType == 'Added' || newIdx >= 0) {
          //permet d'eviter le freeze lié à la carte... on pass saving à true si il ne l'est pas deja
          const covState = context.rootGetters.coverageStateByUiid(
            buildCoverageStateId(wob.newAloDbItem.MIG_ID!, 'detail'),
          )
          let hasSetCovState = false
          if (covState && !covState.saving) {
            covState.saving = true
            hasSetCovState = true
          }
          context.dispatch(types.MISSIONGLOBAL_SELECT_DETAIL_REQUEST, wob.newAloDbItem.MIG_ID).then(() => {
            if (hasSetCovState) Vue.nextTick(() => (covState.saving = false))
          })
        }
      }
      resolve()
    })
  }
}

export default util.classToObject(MissionGlobalAction)
